import { useTranslation } from "react-i18next"
import CountsList from "components/commons/CountsList"
import ModuleActivityChart from "features/core/company/components/ModuleActivityChart"

function AbsenceRequestsStats({
    accepted = 0,
    denied = 0,
    canceled = 0,
    pending = 0
}) {

    const [t, i18n] = useTranslation(["absenceReport"])

    let content = (
        <div className={`card bg-black bg-opacity-10 text-white mb-5`}>
            <div className="card-header">
                <i className="fa-solid fa-chart-pie"></i> {t("absenceReport:menu.absence_stats")}
            </div>

            <div className="card-body text-center">
                <div className="row ">
                    <div className="col-md-3">
                        <CountsList data={
                            [
                                {
                                    key: t("absenceReport:entity.absence.status.pending").toUpperCase(),
                                    value: pending,
                                    foregroundClass: "text-dark",
                                    backgroundClass: "bg-warning"
                                },
                                {
                                    key: t("absenceReport:entity.absence.status.accepted").toUpperCase(),
                                    value: accepted,
                                    backgroundClass: "bg-success"
                                },
                                {
                                    key: t("absenceReport:entity.absence.status.denied").toUpperCase(),
                                    value: denied,
                                    foregroundClass: "text-white",
                                    backgroundClass: "bg-danger"
                                },
                                {
                                    key: t("absenceReport:entity.absence.status.canceled").toUpperCase(),
                                    value: canceled,
                                    foregroundClass: "text-white",
                                    backgroundClass: "bg-secondary"
                                }
                            ]
                        } />
                    </div>
                    <div className="col-md-9">
                        <ModuleActivityChart data={[
                           pending > 0 && { name: t("absenceReport:entity.absence.status.pending"), value: pending, color: "#ffc107" },
                           accepted > 0 && { name: t("absenceReport:entity.absence.status.accepted"), value: accepted, color: "#198754" },
                           denied > 0 && { name: t("absenceReport:entity.absence.status.denied"), value: denied, color: "#dc3545" },
                           canceled > 0 && { name: t("absenceReport:entity.absence.status.canceled"), value: canceled, color: "#6c757d" }
                        ]} />
                    </div>
                </div>
            </div>
        </div>)

    return content
}


export default AbsenceRequestsStats